import { render } from "./send-pick-category-group-messages.vue?vue&type=template&id=a8cc0bb6&lang=pug"
import script from "./send-pick-category-group-messages.vue?vue&type=script&setup=true&lang=js"
export * from "./send-pick-category-group-messages.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__